<template>
  <div class="container">
    <md-card class="dash-content">
      <div class="header-wrapper">
        <PageHeader title="Manage Testimonial" />
        <div class="loader">
          <Wave
            v-if="loading || updating || deleting"
            width="50px"
            color="#d9534f"
          />
        </div>
        <div>
          <md-button class="md-primary" :to="{ name: 'Create Testimonial' }">
            Add New Testimonial
          </md-button>
        </div>
      </div>
      <md-table v-model="testimonial.mdData" md-card md-sort-order="asc">
        <md-table-toolbar class="mb-4">
          <div class="md-toolbar-section-start">
            <!-- <md-button class="md-primary button-icon" disabled>
              Download Excel
              <img src="@/assets/svg/excel.svg" />
            </md-button> -->
          </div>
          <div class="toolbar-filter-wrapper">
            <md-field md-clearable class="md-toolbar-section-end">
              <md-input placeholder="Search by name..." v-model="search" />
            </md-field>
          </div>
        </md-table-toolbar>
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="S/N">{{ item.id }}</md-table-cell>
          <md-table-cell md-label="">
            <div class="display_t">
              <img
                onerror="this.src='https://via.placeholder.com/220x150?text=No%20Image'"
                :src="item.image.length && item.image[0]"
                alt="Avatar"
              />
            </div>
          </md-table-cell>
          <md-table-cell md-label="Name">{{ item.attestant }}</md-table-cell>
          <md-table-cell md-label="Status">{{ item.status }}</md-table-cell>
          <md-table-cell md-label="Actions">
            <md-button
              :disabled="updating"
              class="md-default md-icon-button md-raised btn-icon"
              ><i class="material-icons">edit</i></md-button
            >
            <md-button
              :disabled="updating"
              @click="remove(item.id)"
              class="bggreen md-icon-button md-raised btn-icon"
              ><i class="material-icons">delete</i></md-button
            >
          </md-table-cell>
        </md-table-row>
      </md-table>
      <span v-if="loading" class="b-loading">Loading...</span>
      <pagination
        v-model="testimonial.mdPage"
        :records="testimonial.mdCount"
        :per-page="testimonial.mdPerPage"
        @paginate="updatePagination"
      />
    </md-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters } = createNamespacedHelpers("testimonial");
export default {
  name: "User",
  data() {
    return {
      updating: false,
      deleting: false,
      search: "",
      time: null
    };
  },
  watch: {
    search(val) {
      this.waitForIt(val);
    }
  },

  methods: {
    ...mapActions(["getTestimonial", "deleteTestimonial"]),
    async updatePagination(page) {
      let data = { page };
      if (this.search) data.keyword = this.search;
      await this.getTestimonial(data);
    },
    async submitSearch() {
      await this.getTestimonial({ keyword: this.search });
    },

    waitForIt(val) {
      if (this.time) {
        clearTimeout(this.time);
      }
      this.time = setTimeout(() => this.submitSearch(val), 1000);
    },
    async remove(id) {
      const conf = confirm("Are you sure?");
      if (conf) {
        this.deleting = true;
        await this.deleteTestimonial(id);
        // this.getTestimonial();
        this.deleting = false;
        this.toast("success", "Testimonial deleted");
      }
    }
  },
  created() {},
  mounted() {
    this.getTestimonial();
  },
  computed: {
    ...mapGetters(["testimonial", "loading"]),
    hasPermission() {
      return this.$store.getters["auth/has_module_permission"]("crud");
    }
  }
};
</script>

<style lang="scss" scoped>
.md-table-cell {
  width: 0% !important;
  padding: 0rem 0.8rem;
}

.md-table + .md-table {
  margin-top: 16px;

  thead {
    height: 50px !important;
  }
}

.display_t {
  height: 50px;
  width: 50px;

  img {
    border-radius: 10px;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}
</style>
